import { render, staticRenderFns } from "./FormWizardNumberTab.vue?vue&type=template&id=6f8aaa78&"
import script from "./FormWizardNumberTab.vue?vue&type=script&lang=js&"
export * from "./FormWizardNumberTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports